<template>
	<div class="chat-message">
		<!-- <template v-for="(item, key) in messageGroups">
			<div v-if="item.tag === '<text>'" :key="key" v-html="getDecodedMessage(item.message)">
			</div>
			<a v-else-if="item.tag === '<a>'" :href="item.message" target="_blank">{{ getDecodedMessage(item.message) }}</a>
			<br v-else-if="item.tag === '<br>'">
		</template> -->

		<!-- <div v-html="getDecodedMessage(text)"></div> -->
		<div v-html="text"></div>

<!--		{{ messageGroups }}-->
	</div>
</template>

<script>
import urlConfig from '@/../urlConfig.js';

export default {
	name: "MessageBody",
	props: {
		text: {
			required: true,
			type: String,
		}
	},
	computed: {
		messageGroups() {
			return this.getMessageGroups();
		}
	},
	methods: {
		getDecodedMessage(message) {
			try{
				return decodeURI(message);
			} catch (e) {
				console.warn('Failed to decode URI in chat message body', e);
				return message;
			}
		},
		addText(groups, message, start, length) {
			const text = message.substr(start, length);
			if(text.length !== 0) {
				return groups.push({
					tag: "<text>",
					message: text
				});
			}
		},
		addLink(groups, message, tag, start, length) {
			groups.push({
				tag,
				message: urlConfig.backend + message.substr(start, length)
			});
		},
		addBreak(groups, tag) {
			groups.push({ tag });
		},
		getMessageGroups() {
			const message = this.text;
			let groups = [];
			let start = 0;
			let end = 0;

			while(true) {
				start = message.indexOf('<', start);
				if(start === -1) break;

				this.addText(groups, message, end, start - end);

				end = message.indexOf('>', start) + 1;
				const tag = message.substr(start, end - start);

				if(tag === "<br>") {
					this.addBreak(groups, tag);
				} else if(tag === "<a>") {
					start = end;
					end = message.indexOf('</a>', end);
					this.addLink(groups, message, tag, start, end - start);
					end += 4;
				}

				start = end;
			}

			const last = message.lastIndexOf('>') + 1;
			this.addText(groups, message, last);

			return groups;
		}
	}
};
</script>

<style lang="scss">
	.chat-message {
		word-break: break-word;
		hyphens: auto;
	}
	.tox-menu {
		z-index: 999994 !important;
	}
	.tox-tinymce-aux {
		z-index: 999994 !important;
	}
</style>
